import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

type InitialState = {
	isLoading: boolean
	response: { breakdownProvider: string; breakdownPhoneNumber: string }
	error: { messageHeader: string; message: string }
}

const initialState: InitialState = {
	isLoading: false,
	error: null,
	response: null,
}

export const fetchBreakdownDetails = createAsyncThunk('accidentManagement/fetchFnolList', async (vehicleId: string) => {
	const response = await fetch(`/breakdown/view/` + (vehicleId ? `?vehicleId=${vehicleId}/` : ``)).then(res => res.json())

	return response
})

export const breakdownDetailsSlice = createSlice({
	name: 'breakdownDetails',
	initialState,
	reducers: {},
	extraReducers: builder => {
		builder.addCase(fetchBreakdownDetails.fulfilled, (state, action) => {
			state.response = action.payload
			state.isLoading = false
		}),
			builder.addCase(fetchBreakdownDetails.pending, state => {
				state.isLoading = true
			})
		builder.addCase(fetchBreakdownDetails.rejected, state => {
			state.isLoading = false
			state.error = {
				messageHeader: 'Breakdown details error',
				message: 'There has been an error when retrieving the breakdown details for this vehicle',
			}
		})
	},
})

export const selectBreakdownDetails = state => state.breakdownDetails

export const breakdownDetailsSliceReducer = breakdownDetailsSlice.reducer
